export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('table_label_shelves_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_shelves_goodsName') || 'SKU名称',
    field: 'goodsName',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_shelves_whSkuNo') || '仓库SKU编号',
    field: 'whSkuNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    // editRender: {
    //   name: 'ElInput',
    //   props: {
    //     style: 'width:100%',
    //     maxlength: 50,
    //     size: 'mini',
    //   },
    // },
  },
  {
    title: that.$l('table_label_shelves_whSkuBarcode') || '仓库条码号',
    field: 'whSkuBarcode',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_whReferenceNo') || '自定义号',
    field: 'whReferenceNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    // editRender: {
    //   name: 'ElInput',
    //   props: {
    //     style: 'width:100%',
    //     maxlength: 50,
    //     size: 'mini',
    //   },
    // },
  },
  {
    title: that.$l('table_label_declaredValue') || '申报货值（美元）',
    field: 'declaredValue',
    align: 'center',
    width: 140,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 4,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_pkgLength') || '单品包装长cm',
    field: 'pkgLength',
    align: 'center',
    width: 140,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_pkgWidth') || '单品包装宽cm',
    field: 'pkgWidth',
    align: 'center',
    width: 140,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_pkgHeight') || '单品包装高cm',
    field: 'pkgHeight',
    align: 'center',
    width: 140,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_pkgWeight') || '单品包装重量kg',
    field: 'pkgWeight',
    align: 'center',
    width: 140,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 4,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_shelves_whProductTitle') || '仓库产品中文名称',
    field: 'whProductTitle',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 100,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_whProductTitleEn') || '仓库产品英文名称',
    field: 'whProductTitleEn',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 100,
        size: 'mini',
      },
    },
  },
]
